import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';
import {
  type FileUploadErrorResponse,
  type FileUploadSuccessResponse,
  type StartImportRequest,
  type StartImportResponse,
} from '../data-layer/types';

const { DISCOVERY_FILE_UPLOAD, START_IMPORT } = getObNextGenApiUrlLists();

// Define request types for better type safety
interface UploadDiscoveryFileRequest {
  file: File;
  fileUploadId: string | number;
}

export const discoveryFileUploadApi = createApi({
  reducerPath: 'discoveryFileUploadApi',
  baseQuery: axiosBaseQuery({
    baseUrl: getBaseUrlObNextGen(),
  }),
  tagTypes: ['DiscoveryFileUpload'],
  endpoints: (builder) => ({
    uploadDiscoveryFile: builder.mutation<
      FileUploadSuccessResponse[] | FileUploadErrorResponse,
      UploadDiscoveryFileRequest
    >({
      query: ({ file, fileUploadId }) => {
        const formData = new FormData();

        formData.append('files', file);
        formData.append('appTypeCat', '2');
        formData.append('appTypeKey', fileUploadId.toString());
        formData.append('rowSize', '11');

        return {
          url: DISCOVERY_FILE_UPLOAD,
          method: 'POST',
          data: formData,
        };
      },
      invalidatesTags: ['DiscoveryFileUpload'],
    }),

    startImport: builder.mutation<StartImportResponse, StartImportRequest>({
      query: (payload) => ({
        url: START_IMPORT,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['DiscoveryFileUpload'],
    }),
  }),
});

export const { useUploadDiscoveryFileMutation, useStartImportMutation } =
  discoveryFileUploadApi;
